<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg1"
             ref="statisTitle">
            <span>课堂评价分析</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div id="classroom-funnel" :style="styleObj"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "classroomEva",
        data () {
            return {
                screenWidth: 0, //屏幕宽度
                boxWrapStyleObj: {
                    height: ''
                },
                contentStyleObj: {
                    height: ''
                },
                styleObj: {
                    width: '100%',
                    height: '100%'
                }
            }
        },
        props: {
            heightVal: Number,
            evlPer: Number,
            screenHeight: Number,
            titleHeight: Number
        },
        watch: {
            'titleHeight': 'initBoxHeight',
            'screenHeight': 'initBoxHeight',
            'evlPer': 'initChart'
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight () {
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }
                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + 'px';
                this.contentStyleObj.height = contentHeight + 'px';
            },
            /**
             * 初始化仪表盘
             * @param evlPer
             */
            initChart () {
                var _this = this;
                let fontSize = 16;
                let centerTop = "50%";
                let lineHeight = 20;
                let nameLineHeight = 40;
                let paddingTop = 60;
                if (this.screenWidth <= 1680) {
                    fontSize = 14;
                }
                if (this.screenWidth <= 1028) {
                    fontSize = 12;
                    paddingTop = 40;
                    lineHeight = 15;
                    nameLineHeight = 20;
                }
                if (this.screenWidth <= 1008) {
                    fontSize = 12;
                    lineHeight = 10;
                    nameLineHeight = 15;
                }

                const option = {
                    tooltip: {
                        formatter: "课堂好评率: {c}%"
                    },
                    series: [
                        {
                            type: 'gauge',
                            center: ["50%", centerTop], // 仪表位置
                            radius: "90%", //仪表大小
                            startAngle: 220, //开始角度
                            endAngle: -40, //结束角度
                            axisTick: {
                                length: 10,
                                lineStyle: {
                                    color: '#175380'
                                }
                            },
                            splitLine: {
                                length: 15,
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    color: '#175380'
                                }
                            },
                            axisLabel: {
                                show: false
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    width: 5,
                                    color: 'FED501'
                                }
                            },
                            itemStyle: {
                                color: '#FED501'
                            },
                            pointer: {
                                width: 4,
                                length: '50%',
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 5
                            },
                            title: {show: true,},
                            detail: {
                                formatter: [
                                    '{a|{value}}%',
                                    '{b|课堂好评率}'
                                ].join('\n'),
                                fontSize: fontSize, color: '#0EFCFF',
                                padding: [paddingTop, 0, 0, 0],
                                rich: {
                                    a: {
                                        color: '#0EFCFF',
                                        fontSize: fontSize,
                                        lineHeight: lineHeight
                                    },
                                    b: {
                                        color: '#708ACC',
                                        fontSize: fontSize,
                                        lineHeight: nameLineHeight
                                    }
                                }
                            },
                            data: [{value: _this.evlPer}]
                        },
                        {
                            type: 'gauge',
                            center: ["50%", centerTop], // 仪表位置
                            radius: "60%", //仪表大小
                            startAngle: 220, //开始角度
                            endAngle: -40, //结束角度
                            axisTick: {
                                show: false,
                                length: 10,
                                lineStyle: {
                                    color: '#175380'
                                }
                            },
                            splitLine: {
                                show: false,
                                length: 15,
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    color: '#175380'
                                    // shadowColor : '#fff', //默认透明
                                    // shadowBlur: 10
                                }
                            },
                            axisLabel: {
                                show: false
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    width: 8,
                                    color: [[1, {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 1,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0, color: '#FED501' // 0% 处的颜色
                                        }, {
                                            offset: 1, color: '#EE7601' // 100% 处的颜色
                                        }],
                                        globalCoord: false // 缺省为 false
                                    }]]
                                }
                            },
                            itemStyle: {
                                color: '#FED501',
                                borderColor: '#F29814',
                                borderWidth: 4
                            },
                            title: {show: false},
                            detail: {show: false, formatter: '{value}%', fontSize: fontSize}
                        }
                    ]
                };
                let dataFunnel = this.$echarts.init(document.getElementById("classroom-funnel"));
                dataFunnel.setOption(option);
                window.addEventListener('resize', function () {
                    dataFunnel.resize();
                });
            }
        },
        mounted () {
            //获取屏幕宽度
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";

    .bg1 {
        background-image : url("../../../assets/images/sydataboard/title-bg.png");
    }
</style>
